import { useState } from 'react';
import { Box, Theme, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import clsx from 'clsx';

import { CaseTypeData } from '../../types';
import CategoryList from '../../components/CategoryList/CategoryList';

import CaseTypesSearchSection from './CaseTypesSearchSection';
import QuestionnaireEditSection from './QuestionnairesEditSection';

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: '16px 0px 16px 0px',
    gap: '16px',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  sectionHeight: {
    height: '100%',
  },
  headline: {
    fontSize: '20px',
    fontWeight: '500',
    lineHeight: '23px',
    color: theme.palette.common.white,
  },
}));

const QuestionnairesView = () => {
  const { classes } = useStyles();
  const firmId = localStorage.getItem('firmId');

  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [selectedCaseType, setSelectedCaseType] = useState<CaseTypeData | null>(null);

  if (!firmId) return <></>;

  return (
    <Box className={classes.container}>
      <Box className={classes.section}>
        <Typography className={classes.headline}>{'Categories'}</Typography>
        <CategoryList
          selectedCategory={selectedCategory}
          handleSelect={(category) => setSelectedCategory(category)}
        />
      </Box>
      {selectedCategory && (
        <Box className={classes.section}>
          <Typography className={classes.headline}>{'Case Types'}</Typography>
          <CaseTypesSearchSection
            category={selectedCategory}
            firmId={firmId}
            selectedCaseType={selectedCaseType}
            handleSelect={(caseType) => setSelectedCaseType(caseType)}
          />
        </Box>
      )}

      {selectedCaseType && (
        <Box className={clsx(classes.section, classes.sectionHeight)}>
          <Typography className={classes.headline}>{'Questionnaires'}</Typography>
          <QuestionnaireEditSection firmId={firmId} caseType={selectedCaseType} />
        </Box>
      )}
    </Box>
  );
};

export default QuestionnairesView;
